import { render } from "./CustomerDetail.vue?vue&type=template&id=be7957ec&scoped=true&ts=true"
import script from "./CustomerDetail.vue?vue&type=script&lang=ts"
export * from "./CustomerDetail.vue?vue&type=script&lang=ts"

import "./CustomerDetail.vue?vue&type=style&index=0&id=be7957ec&scoped=true&lang=scss"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be7957ec"]])

export default __exports__